import { NavItem } from '@billy/design-system'
import { TFunction } from 'i18next'

import { FrenchLegalStatus } from '../enums/frenchLegalStatus'
import { LegalStatusDisplayItem } from '../types/legalStatusDisplayItem'

export const getFrenchLegalStatusOptions = (t: TFunction): NavItem<LegalStatusDisplayItem>[] => {
  // Part of items are not translated because they oriented for French Law. Other are the commons.
  const legalStatusItemLabelMap = {
    [FrenchLegalStatus.Auto]: t('settings.organization.organization_info.basic_info.legal_status.auto.label'),
    [FrenchLegalStatus.EI]: t('settings.organization.organization_info.basic_info.legal_status.ei.label'),
    [FrenchLegalStatus.EURL]: 'Entreprise Unipersonnelle à Responsabilité Limitée',
    [FrenchLegalStatus.SARL]: 'Société à Responsabilité Limitée',
    [FrenchLegalStatus.SAS]: 'Société par Actions Simplifiée',
    [FrenchLegalStatus.SASU]: 'Société par Actions Simplifiée Unipersonnelle',
    [FrenchLegalStatus.SA]: 'Société Anonyme',
    [FrenchLegalStatus.SNC]: 'Société en Nom Collectif',
    [FrenchLegalStatus.SCS]: 'Société en Commandite Simple',
    [FrenchLegalStatus.SCA]: 'Société en Commandite par Actions',
    [FrenchLegalStatus.SCI]: 'Société Civile Immobilière',
    [FrenchLegalStatus.SCP]: 'Société Civile Professionnelle',
    [FrenchLegalStatus.SELARL]: "Société d'Exercice Libéral à Responsabilité Limitée",
    [FrenchLegalStatus.SELURL]: "Société d'Exercice Libéral Unipersonnelle à Responsabilité Limitée",
    [FrenchLegalStatus.SELAS]: "Société d'Exercice Libéral par Actions Simplifiée",
    [FrenchLegalStatus.SELASU]: "Société d'Exercice Libéral par Actions Simplifiée Unipersonnelle",
    [FrenchLegalStatus.SELAFA]: "Société d'Exercice Libéral à Forme Anonyme",
    [FrenchLegalStatus.SELCA]: "Société d'Exercice Libéral en Commandite par Actions",
    [FrenchLegalStatus.Association]: 'Association',
    [FrenchLegalStatus.Other]: t('settings.organization.organization_info.basic_info.legal_status.other.label'),
  }

  return (Object.keys(FrenchLegalStatus) as Array<keyof typeof FrenchLegalStatus>).map((item) => ({
    id: item,
    children: item,
    value: {
      displayData: {
        title: item,
        description: legalStatusItemLabelMap[item],
      },
    },
  }))
}
